import role from 'plugins/i18n/entity/role.de.ts'
import building from 'plugins/i18n/entity/building.de.ts'
import unit from 'plugins/i18n/entity/unit.de.ts'

const permission = {
	name: '',
	icon: '',
	fields: {
		role: {
			hp_id: 'Art',
		},
		building: {
			hp_id: 'Liegenschaft',
		},
		unit: {
			hp_id: 'Einheit',
		},
		started_at: '@:common.startedAt',
		ended_at: '@:common.endedAt',
	},
}

export default permission
